import { render, staticRenderFns } from "./MemberStepsReminders.vue?vue&type=template&id=1c636091&scoped=true&lang=pug&"
import script from "./MemberStepsReminders.vue?vue&type=script&lang=js&"
export * from "./MemberStepsReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c636091",
  null
  
)

export default component.exports